import { postMethod } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const ADMIN_OTP_VERIFY = 'ADMIN_OTP_VERIFY';
export const ADMIN_OTP_VERIFY_SUCCESS = 'ADMIN_OTP_VERIFY_SUCCESS';
export const ADMIN_OTP_VERIFY_FAILURE = 'ADMIN_OTP_VERIFY_FAILURE';

// Action Creators
export const adminOtpVerify = () => ({
  type: ADMIN_OTP_VERIFY,
});

export const adminOtpVerifySuccess = (users) => ({
  type: ADMIN_OTP_VERIFY_SUCCESS,
  payload: users,
});

export const adminOtpVerifyFailure = (error) => ({
  type: ADMIN_OTP_VERIFY_FAILURE,
  payload: error,
});

// Thunk Function

export const adminOtpVerifyCallAPI = (body, external) => {
  return async (dispatch) => {
    dispatch(adminOtpVerify());
    try {
      const response = await postMethod(url.otpVerify, body);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(adminOtpVerifySuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(adminOtpVerifyFailure('error'));
      }
    } catch (error) {
      dispatch(adminOtpVerifyFailure(error));
    }
  };
};
